var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.source === 'font-awesome' ? _c('FontAwesomeIcon', _vm._b({
    attrs: {
      "icon": _vm.name
    }
  }, 'FontAwesomeIcon', _vm.$attrs, false)) : _vm.source === 'custom' ? _c('span', _vm._b({
    class: _vm.customIconClass
  }, 'span', _vm.$attrs, false)) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }